/* MedPraxora - Tastaturbedienung fuer das Kategoriemenue in der Kopfzeile.

   Die Ueberschrift "Alle Kategorien" ist im Theme ein <h4>. Sie laesst sich
   mit der Maus bedienen, ist aber mit der Tastatur nicht erreichbar und meldet
   Screenreadern keinen Zustand. Dieses Skript ruestet beides nach, ohne das
   Markup des Themes zu aendern.

   Klicks bleiben bewusst dem Theme-Skript ueberlassen, damit sich der Zustand
   nicht doppelt umschaltet. Hier haengen nur Tastatur-Ereignisse. */
(function () {
  'use strict';

  function init() {
    var wrapper = document.querySelector('#header .vertical_menu');
    if (!wrapper) return;

    var title = wrapper.querySelector('.title_vertical_menu');
    var panel = wrapper.querySelector('.list-vertical_menu');
    if (!title || !panel) return;

    if (!panel.id) panel.id = 'vertikales-kategoriemenue';

    title.setAttribute('role', 'button');
    title.setAttribute('tabindex', '0');
    title.setAttribute('aria-controls', panel.id);
    title.setAttribute('aria-expanded', 'false');

    function setExpanded(open) {
      title.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function toggle(open) {
      wrapper.classList.toggle('active', open);
      setExpanded(open);
    }

    title.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        toggle(!wrapper.classList.contains('active'));
      }
    });

    wrapper.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        if (!wrapper.classList.contains('active')) return;
        toggle(false);
        title.focus();
      }
    });

    /* Maus- und Theme-Interaktionen spiegeln, damit aria-expanded stimmt. */
    wrapper.addEventListener('mouseenter', function () { setExpanded(true); });
    wrapper.addEventListener('mouseleave', function () {
      if (!wrapper.classList.contains('active')) setExpanded(false);
    });
    wrapper.addEventListener('click', function () {
      window.setTimeout(function () {
        setExpanded(wrapper.classList.contains('active'));
      }, 0);
    });

    document.addEventListener('click', function (event) {
      if (wrapper.contains(event.target)) return;
      if (wrapper.classList.contains('active')) toggle(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
